"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCuePoint = void 0;
var constants_1 = require("../constants");
var getWatchedPercentage_1 = require("./getWatchedPercentage");
var isCuePoint = function (mediaDuration, currentTime, cueInterval) {
    if (cueInterval === void 0) { cueInterval = constants_1.DEFAULT_CUE_POINT_PERCENTAGE_INTERVAL; }
    var watchedPercentage = (0, getWatchedPercentage_1.getWatchedPercentage)(currentTime, mediaDuration);
    var isOnRange = watchedPercentage > 0 && watchedPercentage <= 100;
    var isValid = isOnRange && watchedPercentage % cueInterval === 0;
    return isValid;
};
exports.isCuePoint = isCuePoint;
